import { Button, Icons } from '@commenda/kakashi';
import { useState } from 'react';
import { ExportEntityReportModal } from './ExportEntityReportModal';

interface ExportReportButtonProps {
  businessEntityId: number;
  businessEntityName?: string | null;
  onError?: (message: string) => void;
}

export const ExportReportButton = ({
  businessEntityId,
  businessEntityName,
  onError,
}: ExportReportButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button variant="secondary" size="md" onClick={() => setIsOpen(true)}>
        <Icons.Download01 className="size-4" />
        <span>Export</span>
      </Button>
      <ExportEntityReportModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        businessEntityId={businessEntityId}
        businessEntityName={businessEntityName}
        onError={onError}
      />
    </>
  );
};
